import React from 'react';
import {
    Select, MenuItem,
    FormControl, OutlinedInput, InputLabel,
    Checkbox, ListItemText, SelectChangeEvent
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export interface HullOption {
    value: number;
    label: string;
}

interface SelectDropdownProps {
    label: string;
    options: HullOption[];
    value: number;
    multiple?: boolean;
    onChange?: (event: SelectChangeEvent<number>, child: React.ReactNode) => any;
    renderValue?: (selected: unknown) => number;
    selectAllOption?: boolean;
    noSelectionOption?: boolean,
    required?: boolean
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const HullSelectDropdown: React.FC<SelectDropdownProps> = ({
    label,
    options,
    value,
    multiple = false,
    onChange,
    renderValue,
    selectAllOption = false,
    noSelectionOption = false,
    required = false,
    ...rest
}) => {
    const allSelected = Array.isArray(value) ? value.length === options.length : false;
    return (
        <FormControl {...rest} sx={{ width: 550 }}>
            <InputLabel id={`${label}-label`}>{label}</InputLabel>
            <Select
                labelId={`${label}-label`}
                id={`${label}-select`}
                value={value === 0 ? "" : value}
                onChange={onChange}
                multiple={multiple}
                input={<OutlinedInput label={label} />}
                renderValue={renderValue}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDownIcon}
                required={required}
            >
                {noSelectionOption && ( // Render "No selection" option if specified
                    <MenuItem key="no-selection" value={"All"}>
                        <ListItemText primary="All" />
                    </MenuItem>
                )}
                {selectAllOption && (
                    <MenuItem key="select-all" value="all">
                        <Checkbox checked={allSelected} />
                        <ListItemText primary="Select All" />
                    </MenuItem>
                )}
                {options?.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        <ListItemText primary={option.label} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default HullSelectDropdown;
